import * as types from './types';

export const getSpecialMenu = payload => ({
  type: types.SPECIAL_MENU_GET_REQUEST,
  payload,
});

export const getByIdRequest = payload => ({
  type: types.SPECIAL_MENU_GET_BY_ID_REQUEST,
  payload,
});

export const updateOrCreateRequest = payload => ({
  type: types.SPECIAL_MENU_CREATE_OR_UPDATE_REQUEST,
  payload,
});


export const changeFormStep = payload => ({
  type: types.CHANGE_SPECIAL_MENU_FORM_STEP,
  payload,
});

export const resetErrors = payload => ({
  type: types.RESET_SPECIAL_MENU_ERRORS,
  payload,
});

export const deleteSpecialMenu = payload => ({
  type: types.SPECIAL_MENU_DELETE_REQUEST,
  payload,
});

export const resetListData = () => ({
  type: types.RESET_SPECIAL_MENU_LIST_DATA,
});

export const changeSpecialMenuPosition = payload => ({
  type: types.SPECIAL_MENU_CHANGE_POSITION_REQUEST,
  payload,
});

